import { jsx as _jsx } from "react/jsx-runtime";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
import styled, { css } from "styled-components";
import { NUM_ROWS_OF_SWATCHES } from "@faire/retailer/views/product/ProductDetails/AddToCart/OptionSelection/SpecialOptionPicker";
var SWATCH_HEIGHT = 52;
export var OptionsRow = function(param) {
    var isSwatchPicker = param.isSwatchPicker, shouldShowAllSwatches = param.shouldShowAllSwatches, totalNumRowsOfSwatches = param.totalNumRowsOfSwatches, options = param.options;
    if (isSwatchPicker) {
        return /*#__PURE__*/ _jsx(SwatchOptionRow, {
            $expanded: shouldShowAllSwatches,
            $numRows: totalNumRowsOfSwatches,
            role: "radiogroup",
            children: options
        });
    }
    return /*#__PURE__*/ _jsx(OptionRow, {
        role: "radiogroup",
        children: options
    });
};
var SwatchOptionRow = styled.div.withConfig({
    componentId: "sc-3aab279-0"
})([
    "overflow:hidden;transition:height 1s;",
    ";"
], function(props) {
    return css([
        "display:grid;grid-template-columns:repeat(auto-fill,48px);justify-content:space-between;",
        ""
    ], props.$expanded ? css([
        "height:",
        "px;"
    ], props.$numRows * SWATCH_HEIGHT) : css([
        "height:",
        "px;"
    ], Math.min(NUM_ROWS_OF_SWATCHES, props.$numRows) * SWATCH_HEIGHT));
});
var OptionRow = styled(Row).attrs({
    gap: 4
}).withConfig({
    componentId: "sc-3aab279-1"
})([
    "overflow:hidden;position:relative;flex-wrap:wrap;"
]);
